import { ShareArticleModal } from './ShareArticleModal'

export default ShareArticleModal
